import _ from 'underscore';
import Backbone from 'backbone';

import TrackerCollection from 'core/collections/tracker';
import activityModel from 'models/activity';


// Private utilities
var favorites_comparator = function (a, b, attr) {
  var count_a = a.get(attr);
  var count_b = b.get(attr);
  return count_a == count_b ? 0 : count_a > count_b ? -1 : 1;
};

const ActivityCollection = TrackerCollection.extend({
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'activity',
  }),
  model: activityModel,
  // Sort activities by most popular community activities by default
  comparator: function (a, b) {
    return favorites_comparator(a, b, 'num_activitylogs');
  },

  search: function (opts) {
    this.params = _.extend(this.params, opts.params);
    return this.sync('read', this, {
      // this.url() translates this.params to url query string
      url: this.url().replace('?', 'search/?'),
      success: function (data) {
        this.trigger('sync', new ActivityCollection(data.objects));
      }.bind(this)
    });
  },
}, {
  // Static methods

  // Alternate comparator for user's favorites
  user_favorites: function (a, b) {
    return favorites_comparator(a, b, 'num_user_activitylogs');
  },
});

module.exports = ActivityCollection;

/* All activities, including custom activities a user may have added

  Example GET request:
    https://moodhacker.orcasdemo.com/api/tracker/v2/activity/?format=json&username=<username>&api_key=<api_key>

  Response:
  {
    "meta":{
      "limit":0,
      "offset":0,
      "total_count":5
    },
    "objects":[
      {
        "num_activitylogs":14,
        "num_user_activitylogs":2,
        "group":"/api/tracker/v2/activity_group/1/",
        "id":669,
        "is_custom":false,
        "max_time":61,
        "min_time":10,
        "name":"Did physical labor",
        "page":"/api/tracker/v2/page/70/",
        "present_tense":"Do physical labor",
        "resource_uri":"/api/tracker/v2/activity/669/",
        "sequence":1
      },
      {
        "num_activitylogs":3,
        "num_user_activitylogs":0,
        "group":"/api/tracker/v2/activity_group/1/",
        "id":657,
        "is_custom":false,
        "max_time":21,
        "min_time":10,
        "name":"Took the stairs, or parked far away ",
        "page":"/api/tracker/v2/page/63/",
        "present_tense":"Take the stairs or park far away",
        "resource_uri":"/api/tracker/v2/activity/657/",
        "sequence":1
      },
      {
        "num_activitylogs":15,
        "num_user_activitylogs":3,
        "group":"/api/tracker/v2/activity_group/1/",
        "id":666,
        "is_custom":false,
        "max_time":null,
        "min_time":10,
        "name":"Boated, sailed or canoed",
        "page":null,
        "present_tense":"Boat, sail or canoe",
        "resource_uri":"/api/tracker/v2/activity/666/",
        "sequence":1
      },
      {
        "num_activitylogs":1,
        "num_user_activitylogs":4,
        "group":"/api/tracker/v2/activity_group/1/",
        "id":665,
        "is_custom":false,
        "max_time":61,
        "min_time":10,
        "name":"Danced or did fitness class",
        "page":"/api/tracker/v2/page/68/",
        "present_tense":"Dance or do group fitness",
        "resource_uri":"/api/tracker/v2/activity/665/",
        "sequence":1
      },
      {
        "num_activitylogs":0,
        "num_user_activitylogs":1,
        "group":"/api/tracker/v2/activity_group/9/",
        "id":664,
        "is_custom":true,
        "max_time":null,
        "min_time":null,
        "name":"Unicycled around the neighborhood",
        "page":null,
        "present_tense":"Unicycled around the neighborhood",
        "resource_uri":"/api/tracker/v2/activity/664/",
        "sequence":1
      }
    ]
  }

*/



// WEBPACK FOOTER //
// ./static/js/collections/activity.js